import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../app/store/store';
import {
  fetchHelpdeskSettings,
  updateHelpdeskSettings,
} from '../../../entities/helpdesk-settings/model';
import { SettingsToggle } from '@shared/ui/settings-toggle';

const NotificationSettings: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { settings, status } = useSelector(
    (state: RootState) => state.helpdeskSettings,
  );

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchHelpdeskSettings());
    }
  }, [dispatch, status]);

  const handleToggle = useCallback(
    (field: string, value: boolean) => {
      dispatch(updateHelpdeskSettings({ [field]: value }));
    },
    [dispatch],
  );

  if (status === 'loading' || !settings) {
    return (
      <div className="bg-white rounded-xl p-6 shadow-sm">
        <div className="animate-pulse space-y-4">
          <div className="h-5 bg-gray-200 rounded w-1/3"></div>
          <div className="h-12 bg-gray-100 rounded"></div>
          <div className="h-12 bg-gray-100 rounded"></div>
          <div className="h-12 bg-gray-100 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Уведомления операторам */}
      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-[#2d2c2c] mb-4">
          Уведомления операторам
        </h2>

        <div>
          <SettingsToggle
            label="Новое сообщение от клиента"
            description="Уведомить назначенного оператора"
            checked={settings.notify_operator_new_message}
            onChange={(v) => handleToggle('notify_operator_new_message', v)}
          />
          <SettingsToggle
            label="Заявка назначена на оператора"
            description="Email + уведомление в интерфейсе"
            checked={settings.notify_operator_assigned}
            onChange={(v) => handleToggle('notify_operator_assigned', v)}
          />
          <SettingsToggle
            label="Заявка переназначена другому оператору"
            checked={settings.notify_operator_reassigned}
            onChange={(v) => handleToggle('notify_operator_reassigned', v)}
          />
        </div>
      </div>

      {/* Уведомления клиентам */}
      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-[#2d2c2c] mb-4">
          Уведомления клиентам
        </h2>

        <div>
          <SettingsToggle
            label="Заявка зарегистрирована"
            description="Отправить подтверждение с номером заявки"
            checked={settings.notify_client_ticket_created}
            onChange={(v) => handleToggle('notify_client_ticket_created', v)}
          />
          <SettingsToggle
            label="Новый ответ оператора"
            checked={settings.notify_client_new_reply}
            onChange={(v) => handleToggle('notify_client_new_reply', v)}
          />
          <SettingsToggle
            label="Статус заявки изменился"
            description="Решена, Закрыта"
            checked={settings.notify_client_status_changed}
            onChange={(v) => handleToggle('notify_client_status_changed', v)}
          />
          <SettingsToggle
            label="Предупреждение об автозакрытии"
            description="Заявка будет закрыта через N дней"
            checked={settings.notify_client_auto_close_warning}
            onChange={(v) =>
              handleToggle('notify_client_auto_close_warning', v)
            }
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;
